import { Component, Input } from '@angular/core';
import { DiagnosisForReview } from '../../../models/diagnosis.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-historic-diagnose-detail-row',
  templateUrl: './historic-diagnose-detail-row.component.html',
  styleUrls: ['./historic-diagnose-detail-row.component.scss'],
  imports: [TranslateModule]
})
export class HistoricDiagnoseDetailRowComponent {
  readonly dashSpacer = ' — ';
  @Input() diagnosis: DiagnosisForReview;
}
